import React, { useState } from 'react';
import SectionContainer from '../SectionContainer';
import Field, { hasDataInFields } from '../../Field';
import css from './SectionFAQ.module.css';

function SectionFAQ(props) {
  const [openItems, setOpenItems] = useState(new Set());

  const {
    sectionId,
    className,
    rootClassName,
    defaultClasses,
    title,
    description,
    appearance,
    callToAction,
    options,
    blocks = [],
    appearanceImageProps,
  } = props;

  const fieldComponents = options?.fieldComponents;
  const fieldOptions = { fieldComponents };

  const hasHeaderFields = hasDataInFields([title, description, callToAction], fieldOptions);

  // Toggle function for FAQ items
  const toggleFAQ = blockName => {
    setOpenItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(blockName)) {
        newSet.delete(blockName);
      } else {
        newSet.add(blockName);
      }
      return newSet;
    });
  };

  return (
    <SectionContainer
      id={sectionId}
      className={className}
      rootClassName={rootClassName}
      appearance={appearance}
      appearanceImageProps={appearanceImageProps}
      options={fieldOptions}
    >
      {hasHeaderFields ? (
        <header className={defaultClasses.sectionDetails}>
          <Field data={title} className={defaultClasses.title} options={fieldOptions} />
          <Field data={description} className={defaultClasses.description} options={fieldOptions} />
        </header>
      ) : null}

      <div className={css.faqContainer}>
        {blocks.map(block => {
          const isOpen = openItems.has(block.blockName);
          return (
            <div key={block.blockName} className={css.faqItem}>
              <div className={css.faqContent}>
                <h3 className={css.faqQuestion} onClick={() => toggleFAQ(block.blockName)}>
                  <span className={`${css.faqQuestionIcon} ${isOpen ? css.open : ''}`}>
                    {isOpen ? '−' : '+'}
                  </span>
                  {block.title?.content}
                </h3>
                <div className={`${css.faqAnswerWrapper} ${isOpen ? css.open : css.closed}`}>
                  <Field data={block.text} />
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </SectionContainer>
  );
}

export default SectionFAQ;
